/*
  Project: Stockton New
  Author: xfive
 */

import './modules/scrollBarWidth';
import './modules/MainNav';
import Swipers from './modules/swipers';
import Tabs from './modules/Tabs';
import './modules/LoanCalculator';
import EqualButtons from './modules/EqualButtons';
import './modules/Accordion';
import './modules/FindLoanOfficer';
import './modules/Glossary';
import './modules/Podcasts';
import ServiceMacPopup from './modules/ServiceMacPopup';
import './modules/AnchorScroll';
import './modules/Header';
import './modules/Stepper';
import './modules/HeroVideo';
import './modules/recruitment-hero';
import './modules/recruitment-reviews';
import './modules/recruitment-cards-slider';
import './modules/recruitment-gallery';
import TextMedia from './modules/textMedia';
import './modules/IframeCalculator';
import './modules/FeaturedPostsSlider';
import './modules/Search';
import './modules/header-block';
import './modules/Carousel';
import './modules/RelatedPosts';

EqualButtons.init();
Swipers();
Tabs();
ServiceMacPopup();
TextMedia();
